<!-- Hacemos el IF para que no salga en Home -->
@if (breadcrumbs().length > 1) {
  <main>
    <section role="navigation" aria-label="Breadcrumb Navigation">
      <ul class="breadcrumb-list">
        @for (breadcrumb of breadcrumbs(); track breadcrumb.url) {
          <li class="breadcrumb-item" [ngClass]="{ 'bc-active': $last }">
            <a [routerLink]="breadcrumb.url">{{ breadcrumb.label }}</a>
            @if (!$last) {
              <span class="material-symbols-outlined">chevron_right</span>
            }
          </li>
        }
      </ul>
    </section>
  </main>
}
